module.exports = __webpack_public_path__ + "static/media/5.c5c80e04.jpg";